<template>
  <q-select
    dense
    use-input
    clearable
    bottom-slots
    input-debounce="300"
    option-label="nome"
    label="Buscar serviço do catálogo"
    hint="Preenche a descrição e o plano de contas do item abaixo"
    :options="servicosOptions"
    :loading="buscandoServicos"
    :error="Boolean(erroServicoSelecionado)"
    @filter="buscarServicos"
    :model-value="servicoSelecionado"
    @update:model-value="selecionarServico"
  >
    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps">
        <q-item-section>
          <q-item-label>{{ scope.opt.nome }}</q-item-label>
          <q-item-label caption v-if="scope.opt.planodeconta">
            {{ scope.opt.planodeconta.titulo }}
          </q-item-label>
          <q-item-label caption v-else class="text-red">
            Sem classificação financeira válida
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template v-slot:no-option>
      <q-item>
        <q-item-section class="text-grey">Sem Resultados</q-item-section>
      </q-item>
    </template>
    <template v-slot:error>
      <span>{{ erroServicoSelecionado }}</span>
    </template>
  </q-select>
</template>

<script>
import axios from '@/axios-auth';

export default {
  name: 'SeletorServico',
  emits: ['selecionado', 'limpo'],
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      servicoSelecionado: null,
      servicosOptions: [],
      buscandoServicos: false,
      erroServicoSelecionado: '',
      servicoAplicado: null,
    };
  },
  methods: {
    buscarServicos(val, update, abort) {
      this.buscandoServicos = true;

      axios
        .get(this.endpoint, { params: { s: val } })
        .then(res => {
          this.buscandoServicos = false;

          if (res.error || !res.data || !res.data.success) {
            this.$q.notify({
              message: (res.data && res.data.message) || 'Não foi possível buscar os serviços do catálogo.',
              color: 'orange',
              position: 'top-right',
            });
            update(() => {
              this.servicosOptions = [];
            });
            return;
          }

          update(() => {
            this.servicosOptions = res.data.data.servicos;
          });
        })
        .catch(() => {
          this.buscandoServicos = false;
          this.$q.notify({
            message: 'Houve um erro ao buscar os serviços do catálogo',
            color: 'red',
            position: 'top-right',
          });
          abort();
        });
    },
    selecionarServico(servico) {
      // Assigned here instead of via v-model: in Vue 3 an @update:model-value listener
      // declared before v-model runs first, so v-model would put a rejected service back.
      this.servicoSelecionado = servico;
      this.erroServicoSelecionado = '';

      if (!servico) {
        const servicoAplicado = this.servicoAplicado;
        this.servicoAplicado = null;

        if (servicoAplicado
          && this.item.descricao === servicoAplicado.descricao
          && this.item.planodeconta_id === servicoAplicado.planodeconta_id) {
          this.$emit('limpo', { descricao: '', planodeconta_id: null, planodeconta: null });
        }
        return;
      }

      if (!servico.planodeconta) {
        this.erroServicoSelecionado = `O serviço "${servico.nome}" não possui uma classificação financeira ` +
          'válida. Corrija o cadastro do serviço para selecioná-lo aqui.';
        this.servicoSelecionado = null;
        return;
      }

      this.servicoAplicado = {
        descricao: servico.nome,
        planodeconta_id: servico.planodeconta.id,
        planodeconta: servico.planodeconta,
      };
      this.$emit('selecionado', { ...this.servicoAplicado });
    },
  },
};
</script>
